import { DEFAULT_ADDITIONAL_SERVICES } from '../../../pages/ltl-freight/components/freight-browser/freight-browser-container';

import type { FreightBrowserFormState } from '@shipstation/client-common/components/freight-browser';
import type { DimensionUnit } from '@shipstation/client-common/types/dimensions';
import type { WeightUnit } from '@shipstation/client-common/types/weight';

export type RateBrowserFormValues = {
  shipFromId: string;
  shipToCityOrSuburb: string;
  shipToPostalCode: string;
  shipToCountryCode: string;
  isShipToResidentialAddress: boolean;
  weightValue: number;
  weightUnit: string;
  packageDimensions: {
    length: number;
    width: number;
    height: number;
    unit: string;
  };
};

export type RateBrowserToFreightSeedDefaults = {
  defaultWeightUnit: WeightUnit;
  defaultDimensionUnit: DimensionUnit;
};

const WEIGHT_UNIT_BY_RATE_BROWSER_UNIT: Record<string, WeightUnit> = {
  ounce: 'Ounces',
  ounces: 'Ounces',
  gram: 'Grams',
  grams: 'Grams',
  pound: 'Pounds',
  pounds: 'Pounds',
  kilogram: 'Kilograms',
  kilograms: 'Kilograms',
};

const DIMENSION_UNIT_BY_RATE_BROWSER_UNIT: Record<string, DimensionUnit> = {
  inches: 'Inches',
  centimeters: 'Centimeters',
};

export const mapRateBrowserFormToFreightSeed = (
  formValues: RateBrowserFormValues,
  { defaultWeightUnit, defaultDimensionUnit }: RateBrowserToFreightSeedDefaults,
): FreightBrowserFormState => {
  const weightUnit = WEIGHT_UNIT_BY_RATE_BROWSER_UNIT[formValues.weightUnit.toLowerCase()] ?? defaultWeightUnit;
  const dimensionUnit = DIMENSION_UNIT_BY_RATE_BROWSER_UNIT[formValues.packageDimensions.unit.toLowerCase()] ?? defaultDimensionUnit;

  return {
    shipFromId: String(formValues.shipFromId),
    destination: {
      city: formValues.shipToCityOrSuburb,
      state: '',
      postalCode: formValues.shipToPostalCode,
      countryCode: formValues.shipToCountryCode || 'US',
    },
    additionalServices: {
      ...DEFAULT_ADDITIONAL_SERVICES,
      isResidentialDelivery: formValues.isShipToResidentialAddress,
    },
    insurance: { isInsured: false, conditionOfGoods: '', category: '', insuredValue: 0, marksAndNumbers: '' },
    handlingUnits: [
      {
        id: crypto.randomUUID(),
        packagingType: 'Pallet',
        quantity: 1,
        length: formValues.packageDimensions.length,
        width: formValues.packageDimensions.width,
        height: formValues.packageDimensions.height,
        dimensionUnit,
        isStackable: true,
        commodities: [
          {
            id: crypto.randomUUID(),
            description: '',
            freightClass: '',
            nmfcCode: '',
            quantity: 1,
            weight: formValues.weightValue,
            weightUnit,
            isHazmat: false,
            hazmatDetails: null,
            hazmatInfo: null,
            insurance: { isInsured: false, commodityCategoryCode: '', condition: '', declaredValue: 0 },
          },
        ],
      },
    ],
  };
};
